import { ID } from '@datorama/akita';
import { Column, Entity } from '../entity';
import { IEntity } from '../interfaces/models';
import { ColumnType, LanguagePage, PageTitles } from '../interfaces/types';

// TODO: leonel: I added this to use as an example with my repository
//       Joel is free to decide if he wants to keep this file or deleted

export interface IAddressHistory extends IEntity {
  date: Date;
  message: string;
  userName: string;
}

@Entity({
  name: PageTitles.addressHistory,
  language: LanguagePage.addressHistory,
})
export class AddressHistory implements IAddressHistory {
  @Column({
    type: ColumnType.date,
    table: {
      defaultPosition: 2,
    },
  })
  date: Date;

  @Column({
    type: ColumnType.string,
    table: {
      defaultPosition: 3,
    },
  })
  message: string;

  @Column({
    type: ColumnType.string,
    table: {
      defaultPosition: 1,
    },
  })
  userName: string;

  id: ID;
  createdAt?: Date;
  modifiedAt?: Date;
  createdBy?: string;
  modifiedBy?: string;
  href?: string;

  constructor(
    addressHistory: IAddressHistory = {
      id: '',
      date: new Date(),
      message: '',
      userName: '',
      href: '',
      createdBy: '',
      createdAt: new Date(),
      modifiedBy: '',
      modifiedAt: new Date(),
    }
  ) {
    const {
      id,
      date,
      message,
      userName,
      href,
      createdBy,
      createdAt,
      modifiedBy,
      modifiedAt,
    } = addressHistory;

    this.id = id;
    this.date = date;
    this.message = message;
    this.userName = userName;
    this.href = href;
    this.createdBy = createdBy;
    this.createdAt = createdAt;
    this.modifiedBy = modifiedBy;
    this.modifiedAt = modifiedAt;
  }

  // Since ion datepicker receives a string in iso 8601
  // and returns a string, I created this property to manage that
  get createdAtFormatted(): string {
    return this.createdAt.toISOString();
  }

  set createdAtFormatted(date: string) {
    this.createdAt = new Date(date);
  }
}
